import React, { Component } from 'react'
import flattenSchema from '@rwitl/reformed-util/lib/flattenSchema'
import ProductEditor from './ProductEditor'
import unflattenSchema from '@rwitl/reformed-util/lib/unflattenSchema'

class SchemaEditor extends Component {

  onFlatSchemaChange = (flatSchema) => {
    const { onSchemaChange } = this.props
    var schema = unflattenSchema(flatSchema, true)
    onSchemaChange(schema)
  };

  render = () => {
    const { schema, onSchemaChange, branchId } = this.props

    return <ProductEditor
      branchId={branchId}
      flatSchema={flattenSchema(schema)}
      onFlatSchemaChange={this.onFlatSchemaChange}
    />
  }
}

export default SchemaEditor


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/SchemaEditor.js